import styles from './TopStripe.module.css';
import { IconInstagram, IconLinkedin, IconWhatsapp, IconYoutube } from '../../Icons';

export const TopStripe = () => {
    return <div className={styles.Container}>
        <a
            target="_blank"
            href="https://api.whatsapp.com/send?phone=45988191601"
            aria-label="Acesse o Whatsapp oficial do TooMe"
        ><IconWhatsapp size='20' /></a>
        <p>(45) 9 8819-1601</p>
        <a
            target="_blank"
            href="https://www.instagram.com/toome_oficial/?next=%2F"
            aria-label="Acesse o Instagram oficial do TooMe"
        ><IconInstagram size='20' /></a>
        <a
            target="_blank"
            href="https://www.linkedin.com/in/toome-oficial"
            aria-label="Acesse o Linkedin oficial do TooMe"
        ><IconLinkedin size='20' /></a>
        <a
            target="_blank"
            href="https://www.youtube.com/@Toomeoficial"
            aria-label="Acesse o Youtube oficial do TooMe"
        ><IconYoutube size='26' /></a>
    </div>
}